import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMatches } from 'react-router';

import { BRAND_NAME } from '~/common/constants/brand';
import { isRouteHandle } from '~/routing/isRouteHandle';
import { setDocumentTitle } from '~/utils/dom';

export const useBrowserTitle = () => {
  const matches = useMatches();
  const intl = useIntl();

  useEffect(() => {
    const handle = [...matches]
      .reverse()
      .map((match) => match.handle)
      .find(isRouteHandle);

    if (handle) {
      setDocumentTitle(
        intl.formatMessage(handle.title, { brandName: BRAND_NAME }),
      );
    }

    return () => setDocumentTitle();
  }, [matches, intl]);
};
